// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__jhR7c","btnB":"Icon_btnB__9DFrQ"};